import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const RemoteAccessIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <text transform="translate(-.07 -1.56)" fontFamily="MyriadPro-Regular, 'Myriad Pro'" fontSize="2">
   <tspan x="0" y="0" letterSpacing="0em">
    A
   </tspan>
   <tspan x="1.22" y="0" letterSpacing="0em">
    pp_siti
   </tspan>
   <tspan x="6.88" y="0" letterSpacing="0em">
    w
   </tspan>
   <tspan x="8.34" y="0">
    eb_dettagli_d
   </tspan>
   <tspan x="20.08" y="0" letterSpacing="0em">
    a
   </tspan>
   <tspan x="21.04" y="0" letterSpacing="0em">
    tabase_a
   </tspan>
   <tspan x="28.52" y="0" letterSpacing="0em">
    cc
   </tspan>
   <tspan x="30.29" y="0">
    esso{" "}
   </tspan>
   <tspan x="34.4" y="0" letterSpacing="-.01em">
    r
   </tspan>
   <tspan x="35.03" y="0">
    emo
   </tspan>
   <tspan x="38.8" y="0" letterSpacing="0em">
    t
   </tspan>
   <tspan x="39.45" y="0" letterSpacing="0em">
    o
   </tspan>
  </text>
  <g>
   <g>
    <path d="M5.08,18.39c1.91,0,3.66-1.08,4.52-2.77h1.61c.12-.01.24-.06.32-.14l.6-.6.61.61c.09.09.22.14.35.13.13,0,.25-.07.34-.17l.44-.55.75.62c.17.14.42.14.59,0l.75-.62.44.55c.09.11.22.18.36.18h.92c.12,0,.24-.05.33-.14l1.85-1.85c.18-.18.18-.47,0-.65l-1.85-1.85c-.09-.09-.2-.14-.33-.14h-8.09c-.87-1.69-2.61-2.77-4.52-2.77C2.28,8.23,0,10.51,0,13.31c0,2.8,2.28,5.08,5.08,5.08ZM.92,13.31c0-2.29,1.86-4.16,4.16-4.16,1.65,0,3.14.98,3.81,2.49.07.17.24.28.42.28h8.19s1.39,1.39,1.39,1.39l-1.39,1.39h-.51s-.59-.75-.59-.75c-.08-.1-.19-.16-.31-.17-.12-.01-.25.02-.34.1l-.82.68-.82-.68c-.1-.08-.22-.12-.34-.1-.12.01-.24.08-.31.17l-.41.52-.57-.57c-.18-.18-.47-.18-.65,0l-.79.79h-1.71c-.18.01-.35.12-.42.29-.66,1.52-2.16,2.49-3.81,2.49-2.29,0-4.16-1.86-4.16-4.16Z" />
    <path d="M3.23,14.7c.76,0,1.39-.62,1.39-1.39,0-.76-.62-1.39-1.39-1.39-.76,0-1.39.62-1.39,1.39,0,.76.62,1.39,1.39,1.39ZM2.77,13.31c0-.26.21-.46.46-.46.25,0,.46.21.46.46,0,.25-.21.46-.46.46-.26,0-.46-.21-.46-.46Z" />
   </g>
   <g>
    <path d="M4.05,4.34c-.22.22-.22.52,0,.74s.52.22.74,0c2.87-2.87,7.55-2.87,10.42,0,.22.22.52.22.74,0s.22-.52,0-.74c-3.28-3.28-8.63-3.28-11.91,0Z" />
    <path d="M5.53,5.83c-.22.22-.22.52,0,.74s.52.22.74,0c2.05-2.05,5.4-2.05,7.44,0,.22.22.52.22.74,0s.22-.52,0-.74c-2.46-2.46-6.48-2.46-8.93,0Z" />
    <path d="M7.02,7.32c-.22.22-.22.52,0,.74s.52.22.74,0c1.23-1.23,3.24-1.23,4.47,0,.22.22.52.22.74,0s.22-.52,0-.74c-1.64-1.64-4.32-1.64-5.95,0Z" />
   </g>
  </g>
 </svg>,
 "RemoteAccess"
);
